// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"e42de277","572":"e42de277"}[chunkId] + ".chunk.css";
};